import {
  type ConfirmationModalProps as UiConfirmationModalProps,
  ConfirmationModal as UiKitConfirmationModal
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'

type ConfirmationModalProps = UiConfirmationModalProps

/**
 * We use this instead of the one from UI-Kit because this one provides translations out of the box
 */
const ConfirmationModal = ({
  children,
  ...restProps
}: ConfirmationModalProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <UiKitConfirmationModal
      localisation={{
        confirmText: t(generalConstants.CONFIRM),
        title: t(generalConstants.WARNING),
        cancelText: t(generalConstants.CANCEL)
      }}
      modalContent={
        <Text level={1} weight="bold">
          {t(generalConstants.ARE_YOU_SURE)}
        </Text>
      }
      {...restProps}
    >
      {children}
    </UiKitConfirmationModal>
  )
}

export default ConfirmationModal
